import { render } from "./hotel_details.vue?vue&type=template&id=2fa77b59"
import script from "./hotel_details.vue?vue&type=script&lang=js"
export * from "./hotel_details.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__